import { createContext } from 'react';

export const IsCollapsedMenuContext = createContext(false);
